import { Dictionary } from '@models/common';

const currencyMapping: Dictionary = {
  Euro: 'EUR',
  UK: 'GBP',
  US: 'USD',
  EU: 'EUR',
  SA: 'ZAR'
};

export function formatCurrency(amount: string | number, currencyName = 'Euro'): string {
  if (isNaN(+amount)) {
    return '';
  }
  return new Intl.NumberFormat(currencyName !== 'SA' ? 'en-US' : 'en-za', {
    style: 'currency',
    currency: currencyMapping[currencyName] || ''
  })
    .format(+amount)
    .replace(/\D00(?=\D*$)/, '');
}

export function normalizeEmailSettingWithTag(field: string) {
  (field.match(/\[\[(.*?)\]\]/g) || []).forEach((match) => {
    const tagData = match.replaceAll('[[', '').replaceAll(']]', '');
    let value = '';
    try {
      value = JSON.parse(tagData).value;
    } catch (e) {
      value = tagData;
    }
    field = field.replace(match, `{{${value}}}`);
  });
  return field;
}
